require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-bs-sentia-promise.json") })
        }
      }, "path---package-bs-sentia-promise");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-bs-sentia-promise!./.cache/json/package-bs-sentia-promise.json
// module id = 837
// module chunks = 231608221292675